const LAST_APP_ROUTE_KEY = "tb_public_web_last_app_route_v1";

const SAFE_APP_ROUTE_PREFIXES = [
  "/app/home",
  "/app/brief",
  "/app/calendar",
  "/app/news",
  "/app/markets",
  "/app/tasks",
  "/app/saved",
  "/app/settings",
] as const;

const CONTROL_CHARACTER_RE = /[\u0000-\u001f\u007f]/;
const SAFE_ROUTE_BASE_URL = "https://todaysbrief.local";

export function isSafeAppRoute(pathname: string): boolean {
  return SAFE_APP_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function safeAppRouteTarget(target: unknown, fallback = "/app/home"): string {
  if (typeof target !== "string") return fallback;
  const trimmed = target.trim();
  if (
    !trimmed ||
    !trimmed.startsWith("/") ||
    trimmed.startsWith("//") ||
    trimmed.includes("\\") ||
    CONTROL_CHARACTER_RE.test(trimmed)
  ) {
    return fallback;
  }

  try {
    const parsed = new URL(trimmed, SAFE_ROUTE_BASE_URL);
    if (parsed.origin !== SAFE_ROUTE_BASE_URL || !isSafeAppRoute(parsed.pathname)) {
      return fallback;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}

export function rememberAppRoute(target: string): void {
  const route = safeAppRouteTarget(target, "");
  if (!route) return;
  try {
    localStorage.setItem(LAST_APP_ROUTE_KEY, route);
  } catch {
    /* route memory is best effort */
  }
}

export function getLastAppRoute(): string {
  try {
    const route = localStorage.getItem(LAST_APP_ROUTE_KEY);
    return safeAppRouteTarget(route, "/app/home");
  } catch {
    return "/app/home";
  }
}
